module.exports = __webpack_public_path__ + "img/png08.fd805963.png";